export default function Style(){
  return (
    <style>
      {`
html {
  background-color: white !important;
}

.fw-400 {
  font-weight: 400 !important;
}


.btn {
  font-weight: 600 !important;
  font-family: 'Josefin Sans' !important;
  color: #010101;
  letter-spacing: 1px;
  background-color: #FCBD00 !important;
  font-size: 18px;
  padding: 14px 33px !important;
}


@media screen and (max-width:500px) {

  .row-custom {
    --bs-gutter-x: -0.5rem !important;

  }
}

@media screen and (max-width: 1533px) {
  .fs-responsive {
    font-size: 22px;
    line-height: 28px;
  }

  .fs-20 {
    font-size: 18px;
    line-height: 27px;
  }
}

@media screen and (min-width: 1534px) {
  .fs-responsive {
    font-size: 24px;
    line-height: 30px;
  }

  .fs-20 {
    font-size: 20px;
    line-height: 30px;
  }

}

@media screen and (max-width: 1280px) and (min-width: 768px) {
  .min-height-exp {
    min-height: 135px !important;
  }

}

      `}
    </style>
  );
}
